import * as Yup from 'yup';

import { reachabilityOptions as defaultReachabilityOptions } from '../../../defaultFilters';

export const useReachabilityFilter = ({ setFilters }) => {
  const reachabilityOptions = defaultReachabilityOptions;

  const formSchema = Yup.object().shape({
    reachability: Yup.array().of(
      Yup.object().shape({
        label: Yup.string().required(),
        value: Yup.string().required(),
      }),
    ),
  });

  const onSubmit = ({ reachability }) => {
    setFilters({ reachability });
  };

  return {
    formSchema,
    onSubmit,
    reachabilityOptions,
  };
};
